export default class ChorusInvoiceSubmissionMessageResponse {
  public codeRetour!: number;

  public libelle!: string;
}
